// Los endpoints propios del Home. El resto de sus bloques reusa los hooks de las pantallas de
// tiendas, vendedores e inventario — el tablero enlaza, no duplica.
import { useQuery } from '@tanstack/react-query';
import { homeApi } from '@/api/services/retail-wizard/backoffice';

const KEY = ['retail-admin', 'home'] as const;

export function useHomeSalesKpis() {
    return useQuery({
        queryKey: [...KEY, 'sales-kpis'],
        queryFn: () => homeApi.getSalesKpis(),
        // El tablero se mira a lo largo del día: 60s es suficiente frescura sin martillar el silo.
        staleTime: 60_000,
    });
}

/** Cancelaciones de 7 días en su propia query: si falla, solo se caen su KPI y su alerta. */
export function useHomeCancellations7d() {
    return useQuery({
        queryKey: [...KEY, 'cancellations-7d'],
        queryFn: () => homeApi.getCancellations7d(),
        staleTime: 60_000,
    });
}
